import { render, staticRenderFns } from "./widget-FASIN.vue?vue&type=template&id=6ca3c83e&"
import script from "./widget-FASIN.vue?vue&type=script&lang=js&"
export * from "./widget-FASIN.vue?vue&type=script&lang=js&"
import style0 from "./widget-FASIN.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports